import { __decorate, __metadata } from "tslib";
import { IsNotEmptyObjectWithLVS, IsUndefinable } from '@goparrot/common';
import { ApiPropertyOptional } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import { IsDefined } from 'class-validator';
import { WebStoreExposeGroup } from '../interface';
export class PatchWebStoreThemeSubscriptionDto {
    constructor() {
        this.title = {
            fontSize: '14px',
            fontWeight: '500',
        };
        this.terms = {
            fontSize: '11px',
            fontWeight: '400',
        };
        this.checkbox = {
            fontSize: '11px',
            fontWeight: '400',
            width: '15px',
        };
    }
}
__decorate([
    ApiPropertyOptional({ type: () => Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsNotEmptyObjectWithLVS({ always: true }),
    IsDefined({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    __metadata("design:type", Object)
], PatchWebStoreThemeSubscriptionDto.prototype, "title", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsNotEmptyObjectWithLVS({ always: true }),
    IsDefined({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    __metadata("design:type", Object)
], PatchWebStoreThemeSubscriptionDto.prototype, "terms", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsNotEmptyObjectWithLVS({ always: true }),
    IsDefined({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    __metadata("design:type", Object)
], PatchWebStoreThemeSubscriptionDto.prototype, "checkbox", void 0);
//# sourceMappingURL=PatchWebStoreThemeSubscriptionDto.js.map